import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '@mui/material/Pagination';
import moment from 'moment';
import useApi from '../../api/useApi';

function AuditTrail() {
  let user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(sessionStorage.user).organization.id;
  user = user && JSON.parse(sessionStorage.user).user.userName;
  const [audit, setAudit] = useState([]);
  const [{ isLoading, isError, data }, getData] = useApi();
  const [state1, getUserData] = useApi();
  const day = 1000 * 60 * 60 * 24;
  const [formData, setFormData] = useState({ action: '', paramKey: '', users: '' });
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  let itemsPerPage;
  if (window.screen.height <= 768) itemsPerPage = 10;
  else if (window.screen.height > 768 && window.screen.height <= 980) itemsPerPage = 12;
  else if (window.screen.height > 980 && window.screen.height <= 1080) itemsPerPage = 15;
  else if (window.screen.height > 1080 && window.screen.height <= 1440) itemsPerPage = 18;
  else if (window.screen.height > 1440 && window.screen.height <= 1800) itemsPerPage = 21;
  else if (window.screen.height > 1800 && window.screen.height <= 2160) itemsPerPage = 24;
  else if (window.screen.height > 2160) itemsPerPage = 27;
  const [pageCount, setpageCount] = useState(0);
  const [searchFlag, setSearchFlag] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [page, setPage] = useState(1);
  const handleChange = (event, value) => {
    setPage(value);
  };
  useEffect(() => {
    user && getData(`/organization/${orgId}/auditTrail?limit=${itemsPerPage}&page=${page}`, 'GET');
    user && getUserData(`/organization/${orgId}/users`, 'GET');
  }, []);

  useEffect(() => {
    user && getData(`/organization/${orgId}/auditTrail?limit=${itemsPerPage}&page=${page}`, 'GET');
  }, [page]);

  useEffect(() => {
    user &&
      getData(
        `/organization/${orgId}/auditTrail?limit=${itemsPerPage}&page=${page}&action=${formData.action}&param=${formData.paramKey}&user=${formData.users}`,
        'GET'
      );
  }, [formData]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setAudit(data.message);
      if (page === 1) {
        const total = Math.ceil(data.count / itemsPerPage);
        setpageCount(total);
      }
    }
  }, [isLoading, isError, data]);
  useEffect(() => {
    if (!state1.isLoading && !state1.isError && state1.data) {
      setUsersData(state1.data.users);
      // setAudit(data.message);
      // if (page === 1) {
      //   const total = Math.ceil(data.count / itemsPerPage);
      //   setpageCount(total);
      // }
    }
  }, [isLoading, isError, data]);

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    // const timeZoneOffset = _date.getTimezoneOffset();
    // const _timestamp = _date.getTime() - timeZoneOffset * 60 * 1000;
    // let date = new Date(_timestamp);
    // _date.toLocaleString();
    // return `${_date}`;
    // if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
    //   return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    // }

    // if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
    //   return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    // }

    // if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
    //   return `${Math.round(
    //     ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
    //   )} minutes ago`;
    // }

    // return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;
    return moment(_date).fromNow();
  };
  return (
    <div
      className="mt-10 h-full bg-white mx-auto px-3 audit_ui overflow-auto"
      // style={{
      //   boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
      //   borderRadius: '6px',
      //   // left: '14%',
      //   // right: '14%',
      //   width: '78%',
      //   // height: '94vh',
      // }}
    >
      <div className="z-50" style={{ height: '21vh', paddingBottom: '4vh' }}>
        <div
          className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
          style={{ paddingTop: '4vh' }}
        >
          <span className="text-titleColor font-bold text-base mobile_icon2">Audit Trail</span>

          <div className="block lg:flex mt-1 lg:mt-0 ">
            {/* <button
              type="submit"
              className="mt-1 lg:mt-0
               w-full lg:w-max border
               px-3 py-1 rounded-md text-xs ml-3
               font-bold focus:outline-none
               flex justify-center items-center h-7 text-textBlue1 border-primary"
              onClick={() => {
                // downloadExcel('tblData');
              }}
            >
              Date
              <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
            </button>
            <button
              type="submit"
              className="mt-1 lg:mt-0
               w-full lg:w-max border
               px-3 py-1 rounded-md text-xs ml-3
               font-bold focus:outline-none
               flex justify-center items-center h-7 text-textBlue1 border-primary"
              onClick={() => {
                // downloadExcel('tblData');
              }}
            >
              Filter
              <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
            </button> */}
            <button
              type="submit"
              className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs ml-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white mx-3 button_mobile4"
              onClick={() => {
                // downloadExcel('tblData');
              }}
            >
              Report
              <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
            </button>
            {/* <button
              className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
              onClick={() => {

              }}
            >
              Create New
              <img src="assets/img/Create.svg" className="h-2 ml-2 " alt="" />
            </button> */}
            <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl button_search2">
              <input
                type="text"
                placeholder="Search"
                autoComplete="off"
                className="text-textBox bg-transparent focus:outline-none button_search2"
                // value={formData.q}
                name="q"
                // onChange={handleInputChange}
                style={{ borderColor: '#e6e6e6' }}
                onKeyDown={(e) => {
                  // if (e.which === 13) searchData();
                }}
              />
              <img
                src="assets/img/Search.png"
                //  onClick={searchData}
                className="h-4 ml-2 button_search3"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="tbl mobile_view1" style={{ minWidth: '700px' }}>
        <div className="bg-white w-tableWidth m-auto mb-3">
          <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
            <div className="px-8 py-1.5 flex w-full relative bg-primary text-white items-center">
              <div className=" py-1 text-xs font-bold w-2/6 mr-4">
                {' '}
                <div className="relative inline-flex w-full">
                  <svg
                    className="w-3 h-2 absolute top-3 right-5 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#ffffff"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={formData.users}
                    name="users"
                    className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-0 lg:pl-3 w-full bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                    onChange={handleInputChange}
                    style={{ borderColor: '#e6e6e6' }}
                  >
                    <option value="">USERS</option>
                    {usersData.map((x) => (
                      <option value={x.id}>{x.userName}</option>
                    ))}
                    {/* <option value="GET">GET</option>
                    <option value="POST">CREATE</option>
                    <option value="DELETE">DELETE</option>
                    <option value="PATCH">UPDATE</option> */}
                  </select>
                </div>
              </div>
              <div className=" py-1 text-xs font-bold w-2/6">
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#ffffff"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={formData.action}
                    name="action"
                    className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                    onChange={handleInputChange}
                    style={{ borderColor: '#e6e6e6' }}
                  >
                    <option value="">ACTION</option>
                    <option value="GET">GET</option>
                    <option value="POST">CREATE</option>
                    <option value="DELETE">DELETE</option>
                    <option value="PATCH">UPDATE</option>
                  </select>
                </div>
              </div>
              <div className=" py-1 text-xs font-bold w-2/6">
                {' '}
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#ffffff"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={formData.paramKey}
                    name="paramKey"
                    className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                    onChange={handleInputChange}
                    style={{ borderColor: '#e6e6e6' }}
                  >
                    <option value="">PARAMETER</option>
                    <option value="asset">ASSET</option>
                    <option value="device">DEVICE</option>
                    <option value="geofence">GEOFENCE</option>
                    <option value="project">PROJECT</option>
                    <option value="rule">RULE</option>
                    <option value="user">USER</option>
                    <option value="warehouse">WAREHOUSE</option>
                    <option value="webhook">WEBHOOK</option>
                    <option value="zone">ZONE</option>
                    <option value="zplfile">ZPL FILE</option>
                    
                  </select>
                </div>
              </div>
              <div className=" py-1 text-xs font-bold w-4/6">VALUE</div>
              <div className=" py-1 text-xs font-bold w-2/6">STATUS</div>
              <div className=" py-1 text-xs font-bold w-2/6">DONE</div>
            </div>
          </div>
          <div className="hideScroll" style={{ overflowY: 'scroll', height: '64vh' }}>
            <div id="tblData" className="w-full">
              {audit.map((item) => (
                <div
                  className="my-2 px-8 py-1 xl:py-1.5 items-center flex
                relative hover:border-indigo-200 focus-within:border-indigo-200"
                  style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                >
                  <div className="text-role font-semibold w-2/6 py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs mr-4">
                    {user}
                  </div>
                  <div className="text-role font-semibold w-2/6 py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs">
                    {/* Added Alarm Rule Excursion */}
                    {item
                      ? item?.method === 'POST'
                        ? 'CREATE'
                        : item?.method === 'PATCH'
                        ? 'UPDATE'
                        : item?.method
                      : ''}
                  </div>
                  <div className="text-role font-semibold uppercase w-2/6 py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs">
                    {/* Added Alarm Rule Excursion */}
                    {item ? item?.endpoint.split(/[\s/ / ]+/)[1] : ''}
                  </div>
                  <div className="text-role font-semibold w-4/6 py-2 pr-3 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs">
                    {/* Name Excursion */}
                    {/* {item?.paramKey}- */}
                    {item?.paramValue}
                    {/* {item ? item?.method === 'POST' ? 'N/A' : item?.paramKey === null ? 'N/A' : `${item?.paramKey}- ${item?.paramValue}` : ''} */}
                  </div>
                  <div
                    className={`text-${
                      item?.result === 'Success' || item?.result === 'SUCCESS' ? 'green-500' : 'red-500'
                    } w-2/6 py-2 text-left overflow-ellipsis overflow-hidden  font-semibold whitespace-nowrap text-xs`}
                  >
                    {/* Name Excursion */}
                    {item?.result}
                  </div>
                  <div className="text-role font-semibold w-2/6 py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs">
                    {item ? getTimeoffset(item.createdAt) : ''}
                  </div>
                </div>
              ))}
            </div>
          </div>
          {!searchFlag && (
            <div className="block lg:flex mt-1 lg:mt-0">
              <Pagination
                className="mt-4 ml-auto shadow-2xl"
                count={pageCount}
                page={page}
                onChange={handleChange}
                variant="outlined"
                shape="rounded"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default AuditTrail;
